const e = {
  name: "FacebookSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,0c6.6,0,12,5.4,12,12.1c0,6-4.4,11-10.1,11.9v-8.4h2.8l0.5-3.5h-3.3V9.8c0-1,0.5-1.9,2-1.9h1.5V5
			c0,0-1.4-0.2-2.7-0.2c-2.7,0-4.5,1.7-4.5,4.7v2.7h-3v3.5h3V24C4.4,23.1,0,18.1,0,12.1C0,5.4,5.4,0,12,0z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as FacebookSmall
};
